function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_124",
  "data-name": "Grupo 124",
  transform: "translate(-19.785 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-smartphone",
  "data-name": "Icon feather-smartphone",
  transform: "translate(20.785)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_96",
  "data-name": "Caminho 96",
  d: "M9.437,3h9.687a1.958,1.958,0,0,1,1.937,1.978V20.8a1.958,1.958,0,0,1-1.937,1.978H9.437A1.958,1.958,0,0,1,7.5,20.8V4.978A1.958,1.958,0,0,1,9.437,3Z",
  transform: "translate(-7.5 -3)",
  fill: "none",
  stroke: "#ee9033",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_97",
  "data-name": "Caminho 97",
  d: "M18,27h0",
  transform: "translate(-11.219 -11.179)",
  fill: "none",
  stroke: "#ee9033",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.562,
    height: 21.776,
    viewBox: "0 0 15.562 21.776",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone_icon.609130bc.svg";
export { ForwardRef as ReactComponent };